import type {
  DailySale,
  DailySalesData,
} from "../hooks/requests/metrics/dailySales";

export interface GetAllSalesOptions {
  includePlans?: boolean;
  includeFood?: boolean;
  includeMerchandise?: boolean;
}

export const getAllSales = (
  data: DailySalesData,
  options: GetAllSalesOptions = {},
): DailySale[] => {
  const {
    includePlans = true,
    includeFood = true,
    includeMerchandise = true,
  } = options;
  return [
    ...(includePlans
      ? data.planSales.sales.map((sale) => ({
          type: "plan" as const,
          ...sale,
        }))
      : []),
    ...(includeFood
      ? data.foodSales.sales.map((sale) => ({
          type: "food" as const,
          ...sale,
        }))
      : []),
    ...(includeMerchandise
      ? data.merchandiseSales.sales.map((sale) => ({
          type: "merchandise" as const,
          ...sale,
        }))
      : []),
  ].sort((a, b) => {
    const timeA = a.time.split(":").map(Number);
    const timeB = b.time.split(":").map(Number);
    const minutesA = timeA[0] * 60 + timeA[1];
    const minutesB = timeB[0] * 60 + timeB[1];
    return minutesB - minutesA;
  });
};
